import { IActionHandlers, IBoundActionHandlers, IStore } from '../types';

export default function bindActions(store: IStore, actions: IActionHandlers) {
  return Object.keys(actions).reduce((boundActions, actionName) => {
    boundActions[actionName] = actions[actionName].bind(null, store);
    return boundActions;
  }, {} as IBoundActionHandlers);
}
